import { NextRequest, NextResponse } from 'next/server';
import { serialize, parse } from 'cookie';

import {
  getQuoteHashFromUrl,
  getUtmParamsFromUrl,
  updateRedisSession,
} from '../utils/utm.utils';
import { UTMParamsFromUrl, UTMSCookieProp } from '../types/utm.type';
import { cookiesSettings } from '../constants/utm.constants';
import { encodeJsonValues } from '@bolttech/essentials';

export async function utmMiddleware(
  req: NextRequest,
  res: NextResponse,
  utmsDefault: UTMSCookieProp,
  vertical: string,
  locale: string,
): Promise<NextResponse> {
  const url = req.nextUrl;
  const { utmParamsFromUrl, utmParamsFromUrlToCookie } =
    getUtmParamsFromUrl(req);
  const { quoteHFromUrl, quoteXFromUrl } = getQuoteHashFromUrl(req);
  let utms: UTMSCookieProp;

  try {
    const utmsFromCookies = req.cookies.get('utms');
    utms = utmsFromCookies?.value
      ? JSON.parse(utmsFromCookies?.value)
      : utmsDefault;
  } catch (e) {
    console.error('Failed to parse UTM from Cookies:' + e);
    utms = utmsDefault;
  }
  utms[vertical] = { ...utms[vertical], ...utmParamsFromUrlToCookie };
  let utmParamsFromUrlEncoded = utmParamsFromUrl;

  try {
    utms = encodeJsonValues(utms);
    utmParamsFromUrlEncoded = encodeJsonValues(utmParamsFromUrl) as UTMParamsFromUrl

    res.headers.set(
      'Set-Cookie',
      serialize('utms', JSON.stringify(utms), {
        ...cookiesSettings,
        encode: (value) => value,
      }),
    );

    res.headers.append(
      'Set-Cookie',
      serialize('utmsFromUrl', JSON.stringify(utmParamsFromUrlEncoded), {
        ...cookiesSettings,
        encode: (value) => value,
      }),
    );
  } catch (error) {
    console.error('Error to serialize cookies', error);
  }

  // REDIS - Update Session
  const responseRedis = await updateRedisSession(req, url.origin, {
    utms,
    utmsFromUrl: utmParamsFromUrlEncoded,
    quoteHFromUrl,
    quoteXFromUrl,
    locale,
  });
  if (responseRedis instanceof Response) {
    const connectSidParsed = parse(
      responseRedis.headers.get('set-cookie') || '',
    );
    res.headers.append(
      'Set-Cookie',
      serialize('connect.sid', connectSidParsed['connect.sid'], {
        ...cookiesSettings,
      }),
    );
  }

  return res;
}
